import React, { useState } from "react";
import { Table, Pagination, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import {
  useGetCustomerListQuery,
  useDeleteCustomerMutation,
  useBlockCustomerMutation,
} from "../../Services/CustomerAPI";
import Switch from "react-switch";

function Products() {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const {
    data: customerData,
    isLoading,
    error,
    refetch,
  } = useGetCustomerListQuery();
  const [deleteCustomer] = useDeleteCustomerMutation();
  const [blockCustomer] = useBlockCustomerMutation();
  const filteredData =
    customerData?.data?.filter((item) =>
      Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    ) || [];

  const totalPages = Math.max(1, Math.ceil(filteredData.length / itemsPerPage)); // Ensure at least 1 page

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this brand?"
    );
    if (!confirmDelete) return;

    const formData = {
      id: id,
    };
    try {
      await deleteCustomer(formData).unwrap();
      alert("Deleted successfully!");
      refetch();
    } catch (error) {
      console.error("Error deleting brand:", error);
      alert("Failed to delete. Please try again.");
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("status", newStatus);

      const response = await blockCustomer(formData);
      console.log(response);
      refetch();
    } catch (error) {
      console.error("Error updating category status:", error);
    }
  };

  if (isLoading) return <div class="loader"></div>;
  if (error) return <p>Failed to load Data</p>;

  return (
    <div>
      <h3>Customers</h3>
      <div className="content-wrapper">
        <div>
          {/* Search Input */}
          <div className="row justify-flex-end search-box">
            <div className="col-md-6 col-sm-12 col-lg-6 d-flex justify-end gap-10">
              <InputGroup className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th width="20%">Name</th>
                  <th width="30%">Email</th>
                  <th width="25%">Registration Date</th>
                  <th width="20%">Action</th>
                  <th width="5%">Block/<br />Unblock</th>
                </tr>
              </thead>
              <tbody>
                {currentItems?.map((item) => (
                  <tr key={item.id}>
                    <td>
                      {`${item.first_name ? item.first_name + " " : ""}${
                        item.last_name || "N/A"
                      }`}
                    </td>

                    <td>{item.email}</td>

                    <td>
                      {new Date(item.created_at).toLocaleString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </td>
                    <td>
                      <Link to={`/view-customer/${item.id}`}>
                        <FontAwesomeIcon
                          icon={faEye}
                          className=" mx-2"
                          style={{ cursor: "pointer" }}
                        />
                      </Link>
                      <Link to={`/edit-customer/${item.id}`}>
                        <FontAwesomeIcon
                          icon={faEdit}
                          className="text-warning mx-2"
                          style={{ cursor: "pointer" }}
                        />
                      </Link>
                      <FontAwesomeIcon
                        icon={faTrash}
                        className="text-danger mx-2"
                        onClick={() => handleDelete(item.id)}
                        style={{ cursor: "pointer" }}
                      />
                    </td>
                    <td>
                      <Switch
                        onChange={() =>
                          handleStatusChange(item.id, item.status === 1 ? 0 : 1)
                        }
                        checked={item.status === 1}
                        onColor="#4CAF50"
                        offColor="#ccc"
                        checkedIcon={false}
                        uncheckedIcon={false}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Pagination */}
          <Pagination className="d-flex justify-flex-end">
            {totalPages > 1 && (
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
            )}
            {totalPages > 1 && (
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
            )}
            {totalPages > 1 &&
              [...Array(totalPages)]?.map((_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === currentPage}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}

            {totalPages > 1 && (
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
            )}
            {totalPages > 1 && (
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              />
            )}
          </Pagination>
        </div>
      </div>
    </div>
  );
}

export default Products;
